import { render, staticRenderFns } from "./CustomerNatural.vue?vue&type=template&id=7ce08ba8"
import script from "./CustomerNatural.vue?vue&type=script&lang=js"
export * from "./CustomerNatural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports